function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Vue from 'vue';
import si18n from './smart-vue-i18n/index';
import enLocaleElement from "element-ui/lib/locale/lang/en";
import zhLocaleElement from "element-ui/lib/locale/lang/zh-CN";
import locale from "element-ui/lib/locale";
import enLocale from "@/lang/en-US";
import zhLocale from "@/lang/zh-CN";
import enLocale_render from "@/lang/en-US_render";
import zhLocale_render from "@/lang/zh-CN_render";
import enLocale_extension from "@/lang/en-US_extension";
import zhLocale_extension from "@/lang/zh-CN_extension";
var langResources = {
  'en-US': _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    something: {
      //...
    }
  }, enLocaleElement), enLocale), enLocale_render), enLocale_extension),
  'zh-CN': _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    something: {
      //...
    }
  }, zhLocaleElement), zhLocale), zhLocale_render), zhLocale_extension)
};

// *********************  下述代码参考element-ui/lib/locale/format.js begin  *****************//

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
var elLocalFormatter = function template(string, args) {
  return string.replace(RE_NARGS, function (match, prefix, i, index) {
    var result;
    if (string[index - 1] === '{' && string[index + match.length] === '}') {
      return i;
    } else {
      result = hasOwn(args, i) ? args[i] : null;
      if (result === null || result === undefined) {
        return '';
      }
      return result;
    }
  });
};

// *********************  下述代码参考element-ui/lib/locale/format.js end  ******************//

Vue.use(si18n, {
  lang: localStorage.getItem('form_cache') || 'zh-CN',
  messages: langResources
});
locale.i18n(function (key, value) {
  var result = Vue.prototype.$st(key);
  return elLocalFormatter(result, value);
});
export var changeLocale = function changeLocale(langName) {
  Vue.prototype.$si18n.setLang(langName);
  localStorage.setItem('form_cache', langName);
  localStorage.setItem('form_cache', langName);
};
export var translate = function translate(key) {
  return Vue.prototype.$st(key);
};
export default {
  methods: {
    i18nt: function i18nt(key) {
      return this.$st(key);
    },
    /* 如果key1不存在，则查找key2 */i18n2t: function i18n2t(key1, key2) {
      return this.$st2(key1, key2);
    }
  }
};